export { default, type BannerProps } from './Banner';
